import { render, staticRenderFns } from "./AgreementsPage.vue?vue&type=template&id=873d466e&scoped=true"
import script from "./AgreementsPage.vue?vue&type=script&lang=js"
export * from "./AgreementsPage.vue?vue&type=script&lang=js"
import style0 from "./AgreementsPage.vue?vue&type=style&index=0&id=873d466e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873d466e",
  null
  
)

export default component.exports